export const REMIND_CLIENT_OF_SESSION = 'remindClientOfSession';
export const NOTIFY_CLIENT_OF_INVOICE = 'notifyClientOfInvoice';
export const REMIND_CLIENT_OF_LATE_INVOICE = 'remindClientOfLateInvoice';
export const REMIND_CLIENT_OF_UPCOMING_INVOICE = 'remindClientOfUpcomingInvoice';

export const ALL_NED_JOB_TYPES = [
  REMIND_CLIENT_OF_SESSION,
  NOTIFY_CLIENT_OF_INVOICE,
  REMIND_CLIENT_OF_LATE_INVOICE,
  REMIND_CLIENT_OF_UPCOMING_INVOICE,
];



// WEBPACK FOOTER //
// ./src/lib/constants/cron-job-types.js